import styles from './HR.module.css'

interface HRProps {
  className?: string
}

export function HR({ className = '' }: HRProps) {
  return <hr className={`${styles.hr} ${className}`} />
}
